
import React from 'react'

import { Space, Select, Form, Button, Input, Col, Row, Alert, Card, Modal, Table, Spin, Tag, BackTop, Typography } from 'antd';
import useCorreos from '../../hooks/adminexamen/useCorreos';

const { Option } = Select;
const { Text } = Typography;

const Correos = () => {

    const { buscarPlantilla, enviarCorreos, form, valoresForm, setvaloresForm,
            toggleModal, isVisible, columns, destinatarios, girando, rowSelection,
            selectedRowKeys, conteo, enviando, actualizar } = useCorreos()

    return (
        <>
            <Row justify='center'>
                <Col xs={ 24 } md={ 16 }>
                    <Space direction='vertical' style={{ marginBottom: 20 }}>
                        <label>Selecciona una opción para cargar la plantilla</label>

                        <div>
                            <Select
                                style={{
                                    width: 150,
                                    marginRight: 20
                                }}
                                onChange={ buscarPlantilla }
                            >
                                <Option value="inicial">Inicial</Option>
                                <Option value="recordatorio">Recordatorio</Option>
                                <Option value="reporte resultados">Resultados</Option>
                            </Select>

                            <Spin spinning={ girando }/>
                        </div>

                    </Space>



                    {/* formulario :D */}

                    <Form
                        form={ form }
                        layout="vertical"
                        autoComplete="off"
                        name="formulario_correo"
                        onFinish={ enviarCorreos }
                        initialValues={ valoresForm }
                    >
                        <Form.Item
                            label="Título"
                            name="titulo"
                            rules={[
                            {
                                required: true,
                                message: 'Se necesita un título',
                            },
                            ]}
                        >
                            <Input onBlur={e => actualizar('titulo', e.target.value) }/>
                        </Form.Item>

                        <Form.Item
                            label="Contenido"
                            name="cuerpo"
                            rules={[
                            {
                                required: true,
                                message: 'Se necesita un contenido para este correo',
                            },
                            ]}
                        >
                            {/* <Input.TextArea rows={ 7 } onChange={ e => console.log( e.target.value ) }/> */}
                            <Input.TextArea rows={ 7 } onChange={ e => setvaloresForm({ cuerpo: e.target.value}) } onBlur={e => actualizar('cuerpo', e.target.value) }/>

                        </Form.Item>

                        <Form.Item>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                    <Form.Item
                                        name="boton"
                                        initialValue='enviar'
                                    >
                                        <Button type="primary" value='enviar' htmlType="submit">
                                            Enviar correo
                                        </Button>
                                    </Form.Item>

                                    <Button type="link" onClick={ toggleModal }>
                                        Ver destinatarios ({ selectedRowKeys.length })
                                    </Button>
                            </div>
                        </Form.Item>
                    </Form>

                    { enviando && (
                        <Row justify='center'>
                            <Space align='center'>
                                <Spin />
                                <Text>Enviando: { selectedRowKeys.length }</Text>
                            </Space>
                        </Row>
                    )}

                    <Card
                        type="inner"
                        title="Previsualización"
                    >
                        <div dangerouslySetInnerHTML={{ __html: valoresForm.cuerpo }}/>
                    </Card>




                    <Modal title="Seleccione destinatarios" visible={ isVisible } onOk={ toggleModal } onCancel={ toggleModal } cancelButtonProps={{ hidden: true }} width={ 1000 }>

                        <BackTop/>

                        <p className='lead'>
                            Los correos no válidos estarán marcados <Tag color="volcano"> de esta forma </Tag>
                        </p>

                        { conteo() }

                        {/* <Button type="link" onClick={ verCuantasFilasHay }>
                            a ver
                        </Button> */}

                        <Table
                            loading={ girando }
                            columns={ columns }
                            pagination={ false }
                            rowKey = "pk_aspirante"
                            dataSource={ destinatarios }
                            rowSelection={ rowSelection }
                        />

                    </Modal>



                </Col>
            </Row>
        </>
    )
}

export default Correos
